import semver from "semver";

class SessionFormatter {
    format(session) {
        if (!session || !session.parameters) {
            return session;
        }

        if (typeof(session.parameters.SessionSchema) === 'undefined' || session.parameters.SessionSchema === null) {
            return session;
        }

        // otherwise build a stringified version, we are often receiving only 1.7 as a number, lets do a semantic versioning compatible string
        session.parameters.SessionSchema = semver.valid(semver.coerce(session.parameters.SessionSchema));

        return session;
    }
}

export default SessionFormatter;